import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DialogRef } from '@ds/ng-wt-dialog';
import { PlayerService } from '../../services/player.service';

@Component({
    selector: 'ds-side-menus',
    templateUrl: './menus.component.html',
    styleUrls: ['./menus.component.scss']
})
export class MenusComponent implements OnInit {
    menus: any[] = [];

    constructor(private dialogRef: DialogRef,
        private router: Router,
        private playerService: PlayerService
    ) {
        this.menus = this.dialogRef?.data?.menus ?? [];
        this.setDefaultActiveMenu();

        this.playerService.moreMenuUpdate.subscribe((value: boolean) => {
            if(value) {
                this.unSetStyles();
            }
        })
    }

    ngOnInit(): void {
    }

    menuClick(menuItem: any) {
        this.router.navigateByUrl(menuItem?.routerUrl);
        this.unSetStyles();
        const matched = this.menus?.find((item) => item.routerUrl === menuItem.routerUrl);
        if(matched) {
            matched.active = true;
            const el = document.getElementById(matched.name);
            if (el) {
                el.setAttribute('class', 'active');
            }
        }
        this.dialogRef.close();
        this.playerService.refreshMenuActive();
    }

    unSetStyles() {
        this.menus.map((item: any) => {
            item.active = false;
            const el = document.getElementById(item.name);
            if (el) {
                el.removeAttribute('class');
            }
        })
    }

    setDefaultActiveMenu() {
        const currentUrl = window.location.href;
        let activeMenu = this.menus?.find((item) => currentUrl.includes(item.routerUrl));
        if (activeMenu) {
            activeMenu.active = true;
            const el = document.getElementById(activeMenu.name);
            el?.setAttribute('class', 'active');
        }
    }
    
}